import React, { ReactNode, useCallback } from 'react'
import { FormattedHTMLMessage, useNotification } from '@web/walter-ui-kit'
import { FormattedHTMLMessageProps } from '@web/walter-ui-kit/components/FormattedHTMLMessage'

interface Props {
    caption?: FormattedHTMLMessageProps
    icon?: ReactNode
    timeout?: number
    dataPointer?: string
}
function useToast({ caption, icon, timeout = 1500, dataPointer }: Props) {
    const { push } = useNotification()

    return useCallback(() => {
        if (caption) {
            push({
                intent: 'toast',
                content: (
                    <div className="flex gap-2">
                        {icon}
                        <FormattedHTMLMessage {...caption} />
                    </div>
                ),
                timeout,
                dataPointer,
            })
        }
    }, [caption, push, icon, timeout, dataPointer])
}

export default useToast
